var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-flex',{staticStyle:{"max-width":"1120px"},attrs:{"column":""}},[_c('v-layout',{staticStyle:{"padding":"0px"},attrs:{"row":""}},[_c('div',{staticStyle:{"margin":"0","padding":"0"},attrs:{"id":"game_container"}})]),_vm._v(" "),_c('message-log')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-53db2ef6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GameDisplay.vue
// module id = null
// module chunks = 